export const SUPPORT_URL = 'https://www.macmillanlearning.com/support';
